import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-text-center h-mt-50" }
const _hoisted_2 = { class: "b-page-wrapper b-page-wrapper--gray h-flex h-flex-center" }
const _hoisted_3 = { class: "h-flex h-flex-space-between h-flex-dir-column" }
const _hoisted_4 = { class: "h-text-center h-mb-20" }
const _hoisted_5 = { class: "b-base-title h-mt-10" }
const _hoisted_6 = { class: "b-create-password-approve h-flex" }
const _hoisted_7 = { class: "b-create-password-approve-text" }
const _hoisted_8 = { class: "b-create-password-approve-link" }
const _hoisted_9 = { class: "h-flex h-flex-center h-width-100p" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwInput = _resolveComponent("FwInput")!
  const _component_FwFormInput = _resolveComponent("FwFormInput")!
  const _component_FwCheckbox = _resolveComponent("FwCheckbox")!
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_FwPopup = _resolveComponent("FwPopup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('AUTH.CREATE_PASSWORD.HEADER')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FwPopup, {
        centered: true,
        isFixed: true,
        "max-width": _ctx.isDesktop() ? "420px" : "calc(100% - 20px)",
        width: "90%",
        popupClass: "b-popup-style--no-shadow",
        allowBackgroundScrolling: true,
        disableClosingOnClickOutside: true,
        popupBackground: "#fff",
        popupRadius: "20px"
      }, {
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('AUTH.CREATE_PASSWORD.TITLE')), 1)
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_FwFormInput, {
                class: "h-mb-25",
                fieldHasError: _ctx.fieldHasErrorByRule(_ctx.password, _ctx.PASSWORD, _ctx.passwordRules),
                labelType: "label-thin",
                title: _ctx.$t(`AUTH.LOGIN.FORM.PASSWORD.LABEL`)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FwInput, {
                    value: _ctx.password,
                    type: "password",
                    name: "password",
                    placeholder: _ctx.$t(`AUTH.LOGIN.FORM.PASSWORD.PLACEHOLDER`),
                    inputStyle: "gray",
                    error: _ctx.getFieldErrorTextByRule(_ctx.password, _ctx.PASSWORD, _ctx.passwordRules),
                    onUpdate: _cache[0] || (_cache[0] = value => _ctx.password = value),
                    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearServerErrorsBase(_ctx.PASSWORD))),
                    onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addCurrentInputToValidateArray(_ctx.PASSWORD)))
                  }, null, 8, ["value", "placeholder", "error"])
                ]),
                _: 1
              }, 8, ["fieldHasError", "title"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_FwCheckbox, {
                modelValue: _ctx.approve_tcs,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.approve_tcs) = $event)),
                disabled: false,
                name: "checkbox"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.$t('AUTH.CREATE_PASSWORD.TCS_APPROVE.TEXT')) + " ", 1),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('AUTH.CREATE_PASSWORD.TCS_APPROVE.LINK_TEXT')), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_FwButton, {
                class: "h-mt-30",
                disabled: !_ctx.isFormValid,
                borderRadiusType: "small-border",
                onClick: _ctx.sendDataToServer
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('AUTH.CREATE_PASSWORD.BUTTON')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["max-width"])
    ])
  ]))
}